export default __webpack_public_path__ + "static/media/test-three.493ffc17.svg";